import { Observable, switchMap } from 'rxjs';
import { first } from 'rxjs/operators';

export function waitFor<T>(signal$: Observable<any>) {
    return (source$: Observable<T>) =>
        signal$.pipe(
            first(),
            switchMap(() => source$)
        );
}
